import React, { PureComponent } from 'react';
import { HashRouter, withRouter, Link } from 'react-router-dom';
import { Root } from './ReferralList.css';
import PageTitle from '../Layout/components/PageTitle';
import { Button, Dialog, Tab, Tabs } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import { roleStr, roleName, isRole, ROLES } from '../../common/common';
import { timeFormat, toMoney } from '../../common/utils';
import AlertDialog from '../Layout/components/AlertDialog'
import Toast from '../Layout/components/Toast';
import ReferralAdminList from '../ReferralAdminList/ReferralAdminList'
import RefereeList from '../RefereeList/RefereeList';
import ReferorList from '../ReferorList/ReferorList';
import ReferralInfoAdd from './components/ReferralInfoAdd';
import ReferralInfoView from './components/ReferralInfoView';

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
const ADMIN = "admin";
class ReferralList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            openReferralAdd: false,
            openReferralView: false,
            dialogTitle: "",
            dialogState: ADD,
        };
        this.referorTabIdx = 0;
        this.refereeTabIdx = 1;
        this.handleChange = this.handleChange.bind(this);
        this.handleCreateReferral = this.handleCreateReferral.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    render() {

        const {
            tabIndex,
            openReferralAdd,
            openReferralView,
            dialogTitle,
            dialogState
        } = this.state;
        const showTabPanel = () => {
            if (tabIndex === this.referorTabIdx) {
                return <ReferorList></ReferorList>
            } else if (tabIndex === this.refereeTabIdx) {
                return <RefereeList></RefereeList>
            } else {
                return <ReferralAdminList></ReferralAdminList>
            }
        }, showAdminTab = () => {
            if (isRole(ROLES.billingManger)) {
                this.referorTabIdx = 1;
                this.refereeTabIdx = 2;
                return <Tab className={tabIndex === 0 ? "tabSelect" : "tab"} label="All Referrals" />
            }
        };

        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="All Referral" subtitle="MANAGEMENT"></PageTitle>
                    <div className="f h h-r">
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleCreateReferral}>START A Referral</Button>
                    </div>
                </div>
                <Tabs
                    value={tabIndex}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}
                    aria-label="disabled tabs example"
                    TabIndicatorProps={{ style: { display: "none" } }}
                >
                    {showAdminTab()}
                    <Tab className={tabIndex === this.referorTabIdx ? "tabSelect" : "tab"} label="I am the Referor" />
                    <Tab className={tabIndex === this.refereeTabIdx ? "tabSelect" : "tab"} label="I am the Referee" />
                </Tabs>
                {showTabPanel()}
                <Dialog maxWidth={false} open={openReferralAdd}>
                    <ReferralInfoAdd
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        // data={crtMatterObj}
                        // caseId={case_id}
                        // caseNumber={caseNumber}
                        isReferor={this.isReferor}
                        state={dialogState}
                    ></ReferralInfoAdd>
                </Dialog>
            </Root>
        );
    }
    componentDidMount() {
        this.doGetUrlVariable();
        this.props.history.listen(() => {
            this.doGetUrlVariable();
        })
    }
    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }
    doGetUrlVariable() {
        const tabIndex = this.getQueryVariable("tab_index");
        this.setState(() => ({
            tabIndex
        }))
    }
    handleChange(e, newValue) {
        let tabIndex = newValue;
        this.props.history.push("/main/referral?tab_index=" + tabIndex + "&page_index=1&page_size=5");
    }
    getQueryVariable(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return parseInt(decodeURIComponent(r[2]));
        };
        return 0;
    }
    handleCreateReferral() {
        this.openDialog("START A REFERRAL", ADD);
    }
    handleCreate(params) {
        this.addReferral(params);
    }
    handleCancel() {
        this.closeDialog();
    }
    openDialog(title, state) {
        this.setState(() => ({
            openReferralAdd: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    closeDialog() {
        this.setState(() => ({
            openReferralAdd: false,
            openReferralView: false,
        }));
    }
    getReferor(params) {
        const role = roleStr() === "admin" ? "admin" : "common";
        instance.get(BASE_URL + role + '/referrals', { params }).then((res) => {
            const invoiceData = res.data.data;
            const pageObj = res.data.meta;
            // const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(invoiceData)
            this.setState(() => ({
                invoiceData,
                // page_size,
                total_items
            }));
        }).catch((err) => {
            console.log(err)
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }
    addReferral(params) {
        const role = roleStr() === "admin" ? "admin" : "common";
        instance.post(BASE_URL + role + '/referrals', params).then((res) => {
            const tabIndex = this.getQueryVariable("tab_index");
            this.props.history.push("/main/referral?tab_index=" + tabIndex + "&page_index=1&page_size=5");
            this.closeDialog();
        }).catch((err) => {
        })
    }
}

export default withRouter(ReferralList);